import SimplePageHeader from '@/header/SimplePageHeader';
import React from 'react';
import BringFriendsTabs from '@/bringfriends/views/BringFriendsTabs';

function BringFriendsHeader() {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <BringFriendsTabs />
        </SimplePageHeader>
    );
}

export default BringFriendsHeader;
